import { EtpViewModel, MarketingEtpSectionViewModel, ParagraphViewModel } from 'models';

import { PropertyInfoOffersBexFeatures } from 'src/common/__generated__/api';

export function adaptEtp(paymentPolicy: any): EtpViewModel | undefined {
  return paymentPolicy ? adaptPaymentPolicies(paymentPolicy, true) : undefined;
}

export function adaptMarketingSectionEtp(paymentPolicy: any): MarketingEtpSectionViewModel | undefined {
  if (paymentPolicy) {
    const etpPolicies = adaptPaymentPolicies(paymentPolicy, false);

    if (etpPolicies.PAY_NOW?.[0]) {
      const sectionTitle = adaptSectionTitle(paymentPolicy, false);

      return {
        sectionTitle,
        etpPolicies,
      };
    }
  }

  return undefined;
}

function adaptSectionTitle(paymentPolicy: any, adaptMainSection: boolean): string {
  const descriptions = paymentPolicy[0]?.descriptions;
  const description = descriptions && descriptions.filter(item => isAdaptedSection(item, adaptMainSection))[0];

  return description?.heading;
}

function adaptPaymentPolicies(paymentPolicy: any, adaptMainSection: boolean) {
  const etp: EtpViewModel = {
    PAY_NOW: adaptPolicy('PAY_NOW', paymentPolicy, adaptMainSection),
  };

  const payLaterLines = adaptPolicy('PAY_LATER', paymentPolicy, adaptMainSection).filter(item => item?.lines?.length > 0);
  if (payLaterLines?.length > 0) {
    etp.PAY_LATER = payLaterLines;
  }

  const payLaterWithDepositLines = adaptPolicy('PAY_LATER_WITH_DEPOSIT', paymentPolicy, adaptMainSection).filter(
    item => item?.lines?.length > 0
  );
  if (payLaterWithDepositLines?.length > 0) {
    etp.PAY_LATER_WITH_DEPOSIT = payLaterWithDepositLines;
  }

  return etp;
}

function adaptPolicy(
  paymentType: string,
  paymentPolicies: PropertyInfoOffersBexFeatures.PaymentPolicy[],
  adaptMainSection: boolean
): ParagraphViewModel[] {
  return paymentPolicies?.filter(item => item.paymentType === paymentType).map(item => adaptDescriptions(item, adaptMainSection));
}

function adaptDescriptions(paymentPolicy: PropertyInfoOffersBexFeatures.PaymentPolicy, adaptMainSection: boolean): ParagraphViewModel {
  const itemLines = adaptItemLines(paymentPolicy.descriptions, adaptMainSection);
  if (itemLines?.length > 0) {
    return {
      lines: itemLines,
      heading: paymentPolicy.heading,
    } as ParagraphViewModel;
  }
}

function adaptItemLines(descriptions: any, adaptMainSection: boolean): string[] {
  const description = descriptions && descriptions.filter(item => isAdaptedSection(item, adaptMainSection))[0];

  return description?.items?.map(item => item.text);
}

function isAdaptedSection(description: any, adaptMainSection: boolean): boolean {
  if (adaptMainSection) {
    return description.heading === '';
  }

  return description.heading !== '';
}
